import Vue from "vue";
import Router from "vue-router";
import store from '@/store';
import { googlelogin, myinfo } from "@/api/login";
import { setRedirectPath, getRedirectPath, removeRedirectPath } from '@/utils/auth';
import { isMobile } from '@/utils/device';

Vue.use(Router);


async function getBirthday(accessToken) {
  try {
    const response = await fetch(
      "https://people.googleapis.com/v1/people/me?personFields=birthdays",
      {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      }
    );
    if (!response.ok) return null;
    const data = await response.json();
    if (!data.birthdays || data.birthdays.length === 0) return null;
    const birthdayInfo = data.birthdays[0].date;
    const year = birthdayInfo.year ? `${birthdayInfo.year}-` : "";
    const month = String(birthdayInfo.month).padStart(2, "0");
    const day = String(birthdayInfo.day).padStart(2, "0");
    return `${year}${month}-${day}`;
  } catch (error) {
    return null;
  }
}

function parseIdToken(idToken) {
  try {
    if (!idToken || idToken.split(".").length !== 3) {
      throw new Error("idToken 格式错误，不是合法的 JWT");
    }
    const payloadBase64 = idToken.split(".")[1];
    const payloadBase64Normal = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
    const padded = payloadBase64Normal.padEnd(
      payloadBase64Normal.length + (4 - payloadBase64Normal.length % 4) % 4,
      "="
    );
    const payloadStr = decodeURIComponent(escape(atob(padded)));
    const payload = JSON.parse(payloadStr);
    console.log(payloadStr, "用户基本数据");
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp < now) {
      throw new Error("idToken 已过期");
    }
    return {
      picture: payload.picture || "",
      sub: payload.sub || "",
      name: payload.name || "未获取到",
      given_name: payload.given_name || "",
      family_name: payload.family_name || "",
      email: payload.email || "未获取到",
      email_verified: payload.email_verified || false,
      exp: payload.exp
    };
  } catch (error) {
    console.error("idToken 解析失败：", error.message);
    return {
      name: "解析失败",
      email: "解析失败",
      email_verified: false
    };
  }
}

async function login(params) {
  const data = await googlelogin(params);
  if (data.code == 0) {
    localStorage.setItem("hpToken", data.result.token);
  }
  let res = await getInfo();
  if (data.code == 0 && res.code == 0) {
    if (data.result.is_register) {
      const redirectPath = getRedirectPath();
      if (redirectPath) {
        removeRedirectPath();
        window.location.href = redirectPath;
      } else {
        window.location.href = '/shop';
      }
    } else {
      const redirectPath = getRedirectPath();
      if (redirectPath) {
        removeRedirectPath();
        window.location.href = redirectPath;
      } else {
        window.location.href = '/home';
      }
    }
    console.log('res', res);
    store.dispatch("user/setUserData", {
      ...res.result.user_info,
      ...res.result.address_info,
      bank_arr: res.result.bank_arr,
      ewallet_arr: res.result.ewallet_arr
    });
    console.log(data);
  } else {
    window.location.href = '/login';
  }
}

function getInfo() {
  return new Promise(async (resolve) => {
    const data = await myinfo();
    console.log('data', data);
    resolve(data);
  });
}

export const constantRoutes = [
  // ── Public pages (AppHeader + AppFooter provided by PublicLayout) ──
  {
    path: '/',
    component: () => import('@/views/PublicLayout/index.vue'),
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: { activeMenu: 0, title: '首页' }
      },

      {
        path: '/login',
        component: () => import('@/views/login/index'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/reset/:param?',
        component: () => import('@/views/login/reset_password'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/register',
        component: () => import('@/views/login/register'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/backGoogle',
        component: () => import('@/views/login/index'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/about-us',
        component: () => import('@/views/about/about'),
        meta: { activeMenu: 5 }
      },
      {
        path: '/news',
        component: () => import('@/views/news/news'),
        meta: { activeMenu: 6 }
      },
      {
        path: '/newsDetail',
        component: () => import('@/views/news/detail'),
        meta: { activeMenu: 6 }
      },
      {
        path: '/help',
        component: () => import('@/views/help/help'),
        meta: { activeMenu: 3 }
      },
      {
        path: '/help-info',
        component: () => import('@/views/help/help-info'),
        meta: { activeMenu: 3 }
      },
      {
        path: '/refund-policy',
        component: () => import('@/views/help/refund-policy'),
        meta: { activeMenu: 3 }
      },
      {
        path: '/privacy-policy',
        component: () => import('@/views/agreement/agreement1'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/term-conditions',
        component: () => import('@/views/agreement/agreement2'),
        meta: { activeMenu: 0 }
      },
      {
        path: '/shop',
        component: () => import('@/views/shop/shop'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/cart',
        name: 'cart',
        component: () => import('@/views/cart/cart'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/address-list',
        name: 'address-list',
        component: () => import('@/views/cart/AddressList.vue'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/address-add',
        name: 'address-add',
        component: () => import('@/views/cart/AddressAdd.vue'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/address-edit/:id',
        name: 'address-edit',
        component: () => import('@/views/cart/AddressEdit.vue'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/cart/payment.vue'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/shopDetail',
        component: () => import('@/views/shop/shopDetail'),
        meta: { activeMenu: 2 }
      },
      {
        path: '/request-song',
        name: 'request-song',
        component: () => import('@/views/song/request'),
        meta: { activeMenu: 0 }
      },
    ]
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test/index"),
    meta: {
      title: '测试',
      icon: 'el-icon-s-home',
      roles: [1],
    }
  },
  {
    path: "/home",
    component: () => import("@/views/Layout"),
    children: [
      {
        path: "/paymentResult",
        name: 'paymentResult',
        component: () => import("@/views/paymentResult/paymentResult"),
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {
          title: '首页',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/subscription',
        name: 'subscription',
        component: () => import('@/views/subscription/subscription'),
        meta: {
          title: '订阅',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/subscription-info',
        name: 'subscription-info',
        component: () => import('@/views/subscription/subscription-info'),
        meta: {
          title: '订阅-详情',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/subscription-package-management',
        name: 'subscription-package-management',
        component: () => import('@/views/subscription/subscription-package-management.vue')
      },
      {
        path: '/subscription-history',
        name: 'subscription-history',
        component: () => import('@/views/subscription/subscription-history'),
        meta: {
          title: '订阅历史',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/orders',
        name: 'orders',
        component: () => import('@/views/orders/orders'),
        meta: {
          title: '订单',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/orders/orderDetail'),
        meta: {
          title: '订单详情',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/billing',
        name: 'billing',
        component: () => import('@/views/billing/billing'),
        meta: {
          title: '账单',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/billing-detail',
        name: 'BillingDetail',
        component: () => import('@/views/billing/billingDetail_mobile.vue'),
      },
      {
        path: "/settings",
        name: "settings",
        component: () => import("@/views/settings/index"),
        meta: {
          title: 'settings',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: "/Notification",
        name: "Notification",
        component: () => import("@/views/settings/Notification"),
        meta: {
          title: 'settings',
          icon: 'el-icon-s-home',
          roles: [1],
        }
      },
      {
        path: '/payment-link/:id',
        name: 'paymentLink',
        component: () => import('@/views/paymentLink/index.vue'),
      },
      {
        path: '/waiting-payment/:id',
        name: 'paymentGuest',
        component: () => import('@/views/paymentLink/guest.vue'),
      },
      {
        path: '/activation',
        name: 'activation',
        component: () => import('@/views/activation/index.vue'),
        meta: { isActivation: true },
      },
      {
        path: '/activation/payment',
        name: 'activationPayment',
        component: () => import('@/views/activation/payment.vue'),
        meta: { isActivation: true },
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/404/index.vue'),
      },
    ]
  },

];

export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 };
    },
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

const whiteList = [
  '/', "/test", '/login', '/help', '/help-info',
  '/privacy-policy', '/term-conditions', "/register",
  '/shop', '/shopDetail', '/about-us', '/news', '/newsDetail',
  '/refund-policy','/request-song', '/cart'

];

const publicRouteNames = [
  'paymentLink',
  'paymentGuest',
  'not-found',
  'activation',
  'activationPayment'
];

function trackPage() {
  if (typeof gtag === "function") {
    gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.hash,
    });
  }
}

router.afterEach((to, from) => {
  trackPage();
});

function isActivationSubdomain(hostname) {
  return hostname.startsWith('langganan.');
}

function getActivationSubdomain(hostname) {
  const baseHost = hostname.replace(/^www\./, '');
  return `langganan.${baseHost}`;
}

function getBaseDomain(hostname) {
  return hostname.replace(/^langganan\./, '');
}

router.beforeEach(async (to, from, next) => {

  // const hostname = window.location.hostname;
  // const port = window.location.port ? `:${window.location.port}` : '';


  // if (isActivationSubdomain(hostname)) {
  //   if (to.path === '/' && from.path != '/activation') {
  //     return next({ path: '/activation' });
  //   }

  //   if (to.meta && to.meta.isActivation) {
  //     return next();
  //   }

  //   const baseHost = getBaseDomain(hostname);
  //   window.location.href = `${window.location.protocol}//${baseHost}${port}${to.fullPath}`;
  //   return;
  // }

  // // =================================================================
  // // CONDITION 2: USER IN BASE DOMAIN (domain.com)
  // // =================================================================
  // else {
  //   if (to.meta && to.meta.isActivation) {
  //     const activationHost = getActivationSubdomain(hostname);
  //     window.location.href = `${window.location.protocol}//${activationHost}${port}${to.fullPath}`;
  //     return;
  //   }
  // }

  const href = window.location.href;
  if (href.indexOf("backGoogle") > -1 && href.indexOf("access_token") > -1) {
    if (window.location.protocol === 'http:' && window.location.host.indexOf('localhost') === -1) {
      const newHttpsUrl = `https://${window.location.host}${window.location.pathname}#${window.location.hash.slice(1)}`;
      window.location.replace(newHttpsUrl);
    }
    try {
      const accessToken = href.split("access_token=")[1].split("&")[0];
      const idToken = href.split("id_token=")[1]?.split("&")[0];
      const date = await getBirthday(accessToken);
      const basedate = parseIdToken(idToken);
      console.log('Google callback — birthday:', date, 'user:', basedate);
      await login({
        sub: basedate.sub,
        email: basedate.email,
        name: basedate.given_name,
        surname: basedate.family_name,
        birthday: date,
        headimgurl: basedate.picture
      });
    } catch (error) {
      console.error('Google login callback failed:', error);
      window.location.href = '/login';
    }
    return;
  }

  const hasToken = localStorage.getItem("hpToken");
  console.log('hasToken', hasToken);

  if (!hasToken && whiteList.indexOf(to.path) == -1 && !publicRouteNames.includes(to.name)) {
    if (to.path !== '/' && to.path !== '/login') {
      setRedirectPath(to.fullPath);
    }
    console.log('跳到登录页--------');
    next('/login');
  } else {
    if (!hasToken) {
      next();
      return;
    }
    if (!store.getters.userData.id_no && whiteList.indexOf(to.path) == -1 && !publicRouteNames.includes(to.name)) {
      console.log('需要getinfo--------');
      let res = await getInfo();
      if (res.code == 0) {
        console.log('res', res);
        store.dispatch("user/setUserData", {
          ...res.result.user_info,
          ...res.result.address_info,
          bank_arr: res.result.bank_arr,
          ewallet_arr: res.result.ewallet_arr
        });
      }
      next();
    } else {
      console.log('直接放心');
      next();
    }
  }
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

export default router;